/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.sbf-overview', {
            parent: 'board.project-detail',
            url: '/sbf-overview',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title3'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/sbf-overview/sbf-overview.html',
                    controller: 'SbfOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
